/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElTableColumn as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5738ad5a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "google-logout"
};
const _hoisted_2 = {
  class: "url"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("复制");
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips",
  style: {
    "margin-bottom": "10px",
    "color": "#999"
  }
}, "应谷歌政策要求，需在数据安全表单内填写账户注销的网页地址", -1));
const _hoisted_5 = {
  key: 1,
  class: "flex items-center marginB20"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "协议弹窗开关：", -1));
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存弹窗开关");
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "配置协议地址：", -1));
const _hoisted_9 = {
  class: "input-row"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "*", -1));
const _hoisted_11 = {
  class: "input-row"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "*", -1));
const _hoisted_13 = {
  class: "input-row"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "*", -1));
const _hoisted_15 = {
  class: "input-row"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "*", -1));
const _hoisted_17 = /*#__PURE__*/_createTextVNode("保存");
const _hoisted_18 = /*#__PURE__*/_createTextVNode("新增协议配置");
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { URLREG } from '@/utils/reg';
import { apiUsdkSaveAgreement, apiUsdkSaveGlobalSdk } from '@/api/usdk';
import { copyText } from '@ultra/share/utils';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const type = ref('add');
    const channel = ref();
    const confirmLoading = ref(false);
    const form = ref({
      id: '',
      var: 'hg.switch.showAgr',
      val: 1,
      surfix: '',
      caption: ''
    });
    const agrType = ref(1);
    const isChange = ref(false);
    const tableData = ref([]);
    const lang = [{
      label: '简体中文',
      val: 'zh_CN'
    }, {
      label: '繁体中文',
      val: 'zh_HK'
    }, {
      label: '英语',
      val: 'en'
    }, {
      label: '日语',
      val: 'ja'
    }, {
      label: '越南语',
      val: 'vi'
    }, {
      label: '俄语',
      val: 'ru'
    }, {
      label: '法语',
      val: 'fr'
    }, {
      label: '德语',
      val: 'de'
    }, {
      label: '意大利语',
      val: 'it'
    }, {
      label: '葡萄牙语',
      val: 'pt'
    }, {
      label: '印尼语',
      val: 'in'
    }, {
      label: '泰语',
      val: 'th'
    }, {
      label: '西班牙语',
      val: 'es'
    }, {
      label: '韩语',
      val: 'ko'
    }];
    const temp = {
      lang: undefined,
      userAgrUrl: '',
      privacyAgrUrl: '',
      ruleAgrUrl: '',
      woffAgrUrl: '',
      loading: false
    };
    const googleLogoutUrl = computed(() => {
      var _channel$value;
      let url = 'https://www.ultrasdk.com/logout/';
      url += `?source=1&productId=${(_channel$value = channel.value) === null || _channel$value === void 0 ? void 0 : _channel$value.pcode}`;
      return url;
    });
    const handleClose = () => {
      dialogVisible.value = false;
      tableData.value = [temp];
      if (isChange.value) {
        emits('success');
      }
      isChange.value = false;
    };
    const handleOk = () => {
      confirmLoading.value = true;
      apiUsdkSaveGlobalSdk(form.value).then(res => {
        if (res.code === 0) {
          isChange.value = true;
          handleClose();
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    const handleClick = (type, data, index) => {
      if (type === 'add') {
        let last = tableData.value[tableData.value.length - 1];
        if (last) {
          const condition = agrType.value === 1 ? !last.lang || !last.userAgrUrl && !last.privacyAgrUrl && !last.ruleAgrUrl : !last.lang || !last.woffAgrUrl;
          if (condition) {
            ElMessage.error('请完善上一条协议!');
            return;
          }
        }
        tableData.value.push({
          ...temp
        });
      } else if (type === 'save') {
        const condition = agrType.value === 1 ? !(data.lang && (!!data.userAgrUrl || !!data.privacyAgrUrl || !!data.ruleAgrUrl)) : !(data.lang && data.woffAgrUrl);
        // const condition = !data.lang ||!data.userAgrUrl || !data.privacyAgrUrl || !data.ruleAgrUrl;
        if (condition) {
          ElMessage.error('请完善协议信息!');
          return;
        }
        if (agrType.value === 1) {
          if (!(data.userAgrUrl && URLREG.test(data.userAgrUrl) || !data.userAgrUrl) || !(data.privacyAgrUrl && URLREG.test(data.privacyAgrUrl) || !data.privacyAgrUrl) || !(data.ruleAgrUrl && URLREG.test(data.ruleAgrUrl) || !data.ruleAgrUrl)) {
            ElMessage.error('请输入正确的协议地址!');
            return;
          }
        } else {
          if (!(data.woffAgrUrl && URLREG.test(data.woffAgrUrl))) {
            ElMessage.error('请输入正确的协议地址!');
            return;
          }
        }
        data.loading = true;
        let params = data;
        params.gid = form.value.gid;
        params.cid = channel.value.cid;
        params.type = agrType;
        apiUsdkSaveAgreement(params).then(res => {
          if (res.code === 0) {
            isChange.value = true;
            emits('success');
          }
        }).finally(() => {
          data.loading = false;
        });
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      channel.value = payload.channel;
      agrType.value = payload.tabType;
      const obj = payload.channel;
      form.value.gid = payload.gid;
      form.value.cid = obj.cid;
      form.value.id = obj.confId;
      form.value.surfix = obj.surfix;
      form.value.val = obj.enable;
      tableData.value = JSON.parse(JSON.stringify(obj.agreements)).map(item => {
        return item;
      });
      type.value = payload.type;
    };
    const copyUrl = url => {
      copyText(url).then(() => {
        ElMessage.success('复制成功!');
      });
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_table_column = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_table = __unplugin_components_5;
      const _component_el_dialog = __unplugin_components_6;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        "before-close": () => handleClose(),
        title: type.value === 'add' ? '新增协议配置' : `[${channel.value.cname}]协议配置管理`,
        width: "1000px"
      }, {
        default: _withCtx(() => [[4, 241].includes(channel.value.cid) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(" 谷歌注销地址：" + _toDisplayString(_unref(googleLogoutUrl)) + " ", 1), _createVNode(_component_el_button, {
          plain: "",
          size: "small",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => copyUrl(_unref(googleLogoutUrl)))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]), _hoisted_4])) : _createCommentVNode("", true), agrType.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", null, [_createVNode(USwitch, {
          modelValue: form.value.val,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.val = $event)
        }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
          loading: confirmLoading.value,
          class: "marginL30",
          type: "primary",
          onClick: handleOk
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["loading"])])) : _createCommentVNode("", true), _hoisted_8, _createVNode(_component_el_table, {
          data: tableData.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "语言",
            prop: "username"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.lang,
              "onUpdate:modelValue": $event => scope.row.lang = $event,
              placeholder: "请选择语言"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(lang, item => {
                return _createVNode(_component_el_option, {
                  key: item.val,
                  label: item.label,
                  value: item.val
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), agrType.value === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_table_column, {
            label: "用户协议地址",
            prop: "userAgrUrl"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_input, {
              modelValue: scope.row.userAgrUrl,
              "onUpdate:modelValue": $event => scope.row.userAgrUrl = $event,
              placeholder: "请输入用户协议地址"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "隐私协议地址",
            prop: "privacyAgrUrl"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_input, {
              modelValue: scope.row.privacyAgrUrl,
              "onUpdate:modelValue": $event => scope.row.privacyAgrUrl = $event,
              placeholder: "请输入隐私协议地址"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "游戏管理协议地址",
            prop: "ruleAgrUrl"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_input, {
              modelValue: scope.row.ruleAgrUrl,
              "onUpdate:modelValue": $event => scope.row.ruleAgrUrl = $event,
              placeholder: "请输入游戏管理协议地址"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
            _: 1
          })], 64)) : (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "注销协议地址",
            prop: "woffAgrUrl"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_input, {
              modelValue: scope.row.woffAgrUrl,
              "onUpdate:modelValue": $event => scope.row.woffAgrUrl = $event,
              placeholder: "请输入注销协议地址"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
            _: 1
          })), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              loading: scope.row.loading,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => handleClick('save', scope.row, scope.$index)
            }, {
              default: _withCtx(() => [_hoisted_17]),
              _: 2
            }, 1032, ["loading", "onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_button, {
          class: "marginT20",
          style: {
            "width": "100%"
          },
          onClick: _cache[2] || (_cache[2] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "before-close", "title"]);
    };
  }
});